"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _components = require("../components");

var _Account = require("./Account/Account");

var _Account2 = _interopRequireDefault(_Account);

var _App = require("./App/App");

var _App2 = _interopRequireDefault(_App);

var _Bridge = require("./Apps/Bridge");

var _Bridge2 = _interopRequireDefault(_Bridge);

var _Megascans = require("./Apps/Megascans");

var _Megascans2 = _interopRequireDefault(_Megascans);

var _Mixer = require("./Apps/Mixer");

var _Mixer2 = _interopRequireDefault(_Mixer);

var _Articles = require("./Blog/Articles");

var _Articles2 = _interopRequireDefault(_Articles);

var _Blog = require("./Blog/Blog");

var _Blog2 = _interopRequireDefault(_Blog);

var _BuyPoints = require("./BuyPoints/BuyPoints");

var _BuyPoints2 = _interopRequireDefault(_BuyPoints);

var _ChooseSubscription = require("./ChooseSubscription/ChooseSubscription");

var _ChooseSubscription2 = _interopRequireDefault(_ChooseSubscription);

var _ConvertPoints = require("./ConvertPoints/ConvertPoints");

var _ConvertPoints2 = _interopRequireDefault(_ConvertPoints);

var _CookiePolicy = require("./CookiePolicy/CookiePolicy");

var _CookiePolicy2 = _interopRequireDefault(_CookiePolicy);

var _Articles3 = require("./Credits/Articles");

var _Articles4 = _interopRequireDefault(_Articles3);

var _Enterprise = require("./Enterprise/Enterprise");

var _Enterprise2 = _interopRequireDefault(_Enterprise);

var _ForgotPassword = require("./ForgotPassword/ForgotPassword");

var _ForgotPassword2 = _interopRequireDefault(_ForgotPassword);

var _Gallery = require("./Gallery/Gallery");

var _Gallery2 = _interopRequireDefault(_Gallery);

var _Home = require("./Home/Home");

var _Home2 = _interopRequireDefault(_Home);

var _Login = require("./Login/Login");

var _Login2 = _interopRequireDefault(_Login);

var _LoginWithEpic = require("./LoginWithEpic/LoginWithEpic");

var _LoginWithEpic2 = _interopRequireDefault(_LoginWithEpic);

var _LegacyAuth = require("./LegacyAuth/LegacyAuth");

var _LegacyAuth2 = _interopRequireDefault(_LegacyAuth);

var _Logout = require("./Logout/Logout");

var _Logout2 = _interopRequireDefault(_Logout);

var _Mixer3 = require("./Mixer/Mixer");

var _Mixer4 = _interopRequireDefault(_Mixer3);

var _ReleaseNotes = require("./Mixer/ReleaseNotes");

var _ReleaseNotes2 = _interopRequireDefault(_ReleaseNotes);

var _NotFound = require("./NotFound/NotFound");

var _NotFound2 = _interopRequireDefault(_NotFound);

var _Plugins = require("./Plugins/Plugins");

var _Plugins2 = _interopRequireDefault(_Plugins);

var _Pricing = require("./Pricing2/Pricing");

var _Pricing2 = _interopRequireDefault(_Pricing);

var _RedirectToExternalURL = require("./RedirectToExternalURL/RedirectToExternalURL");

var _RedirectToExternalURL2 = _interopRequireDefault(_RedirectToExternalURL);

var _Subscribe = require("./Subscribe/Subscribe");

var _Subscribe2 = _interopRequireDefault(_Subscribe);

var _Upgrade = require("./Upgrade/Upgrade");

var _Upgrade2 = _interopRequireDefault(_Upgrade);

var _reactRouter = require("react-router");

var _underscore = require("underscore");

var _underscore2 = _interopRequireDefault(_underscore);

var _redialOnRouterEvent = require("../utils/redialOnRouterEvent");

var _redialOnRouterEvent2 = _interopRequireDefault(_redialOnRouterEvent);

var _EpicMigration = require("../EpicMigration/pages/EpicMigration");

var _EpicMigration2 = _interopRequireDefault(_EpicMigration);

var _LinkEpicAccount = require("../EpicMigration/pages/LinkEpicAccount");

var _LinkEpicAccount2 = _interopRequireDefault(_LinkEpicAccount);

var _eol = require("../redux/modules/eol");

var _RedirectToExternalSite = require("../utils/RedirectToExternalSite");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (store) {
  var requireLogin = function requireLogin(nextState, replace, cb) {
    var _store$getState = store.getState(),
        loggedIn = _store$getState.auth.loggedIn;

    if (!loggedIn) {
      var pathname = "/login";

      replace({
        pathname: pathname,
        query: { returnTo: nextState.location.pathname },
        state: { modal: true }
      });
    }

    var plan = nextState.params.plan;


    if (plan === "studio") {
      var _pathname = "/pricing";
      replace({
        pathname: _pathname
      });
    }

    cb();
  };

  var queryParamFiltering = function queryParamFiltering(query) {
    if (query.indexOf("filter") > -1) {
      return query.replace("filter", "search").replace("|", "&search=");
    }
    return query;
  };

  var ExternalRedirect = function ExternalRedirect(props) {
    var location = props.location;

    if (__CLIENT__) {
      var basePath = window.location.protocol + "//" + window.location.hostname;
      if (location.pathname.indexOf("megascans/library/") > -1) {
        var pathname = location.pathname.replace("library", "home");
        (0, _RedirectToExternalSite.checkRedirectRequired)(basePath + pathname + queryParamFiltering(location.search));
      } else if (location.pathname.indexOf("megascans/library") > -1) {
        var _pathname2 = "/megascans/home"; //location.pathname.replace("library", "home");
        (0, _RedirectToExternalSite.checkRedirectRequired)(basePath + _pathname2 + queryParamFiltering(location.search));
      } else if (location.pathname.indexOf("megascans/home") > -1) {
        var _pathname3 = location.pathname;
        (0, _RedirectToExternalSite.checkRedirectRequired)(basePath + _pathname3 + queryParamFiltering(location.search));
      } else if (location.pathname.indexOf("megascans/") > -1) {
        var _pathname4 = location.pathname;
        (0, _RedirectToExternalSite.checkRedirectRequired)(basePath + _pathname4 + queryParamFiltering(location.search));
      } else if (location.pathname.indexOf("/assets/") > -1) {
        var _pathname5 = "/megascans/home?assetId=";
        (0, _RedirectToExternalSite.checkRedirectRequired)(basePath + _pathname5 + location.pathname.substring(location.pathname.lastIndexOf("/") + 1));
      } else if (location.pathname.startsWith("/termsmixer") > -1) {
        window.location.href = "https://legal.epicgames.com/en-US/epicgames/mixer";
      } else if (location.pathname.indexOf("/terms") > -1 && location.hash.indexOf("#privacy-policy") > -1) {
        window.location.href = "https://www.epicgames.com/site/en-US/privacypolicy";
        return _react2.default.createElement("div", null);
      } else if (location.pathname.indexOf("/terms") > -1) {
        window.location.href = "https://www.unrealengine.com/eula/content";
        return _react2.default.createElement("div", null);
      }
    }
    return _react2.default.createElement("div", null);
  };

  var redial = (0, _redialOnRouterEvent2.default)(store);

  return _react2.default.createElement(
    _reactRouter.Route,
    { onChange: redial, onEnter: _underscore2.default.partial(redial, null), component: _App2.default },
    _react2.default.createElement(_reactRouter.Route, { path: "/", component: _Home2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: "/redirect", component: _RedirectToExternalURL2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: "/login", component: _Login2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: "/login-with-epic", component: _LoginWithEpic2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: "/legacy-auth", component: _LegacyAuth2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: "/logout", component: _Logout2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: "/forgot", component: _ForgotPassword2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: "/ninetydays-credits", component: _Articles4.default }),
    _react2.default.createElement(_reactRouter.Route, { path: "/account", component: _Account2.default, onEnter: requireLogin }),
    _react2.default.createElement(_reactRouter.Route, { path: "/convert-points", component: _ConvertPoints2.default, onEnter: requireLogin }),
    _react2.default.createElement(_reactRouter.Route, { path: "/products/mixer", component: _Mixer4.default }),
    _react2.default.createElement(_reactRouter.Route, { path: "/products/mixer/:platform/:version", component: _ReleaseNotes2.default }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "subscribe/personal-annual", to: "/pricing" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "subscribe/indie-annual", to: "/pricing" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "megascans/library/account", to: "/account" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "megascans/library/products/mixer", to: "/products/mixer" }),
    _react2.default.createElement(_reactRouter.Redirect, {
      from: "megascans/library/products/mixer/:platform/:version",
      to: "/products/mixer/:platform/:version"
    }),
    _react2.default.createElement(_reactRouter.Route, { path: "/epic-migration", component: _EpicMigration2.default, onEnter: requireLogin }),
    _react2.default.createElement(_reactRouter.Route, { path: "/link-epic-account", component: _LinkEpicAccount2.default }),
    _react2.default.createElement(
      _reactRouter.Route,
      { name: "library", path: "megascans/library", component: ExternalRedirect },
      _react2.default.createElement(_reactRouter.Route, { path: "collections/:collectionType", component: ExternalRedirect }),
      _react2.default.createElement(_reactRouter.Route, { path: "collections/:collectionType/:collectionId", component: ExternalRedirect }),
      _react2.default.createElement(_reactRouter.Route, { path: ":view", component: ExternalRedirect }),
      _react2.default.createElement(_reactRouter.IndexRoute, { component: ExternalRedirect })
    ),
    _react2.default.createElement(_reactRouter.Redirect, { from: "megascans/library/archviz", to: "/pricing" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "megascans/home", to: "/megascans/library" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "megascans/library/archviz/collections/:collectionType", to: "/pricing" }),
    _react2.default.createElement(_reactRouter.Redirect, {
      from: "megascans/library/archviz/collections/:collectionType/:collectionId",
      to: "/pricing"
    }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "megascans/library/archviz/:view", to: "/pricing" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/megascans/library/archviz/packs/:pack", to: "/pricing" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/megascans/library/archviz/collections/nature/:pack", to: "/pricing" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/archviz", to: "/pricing" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/indie", to: "/pricing" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/business", to: "/pricing" }),
    _react2.default.createElement(_reactRouter.Redirect, {
      from: "/library/collections/:collectionType",
      to: "/megascans/library/collections/:collectionType"
    }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/manage/:asset/:manage", to: "/assets/:asset/:manage" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/library", to: "/megascans/library" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/library/account", to: "/megascans/library/account" }),
    _react2.default.createElement(_reactRouter.Redirect, {
      from: "/library/collections/:collectionType/:collectionId",
      to: "/megascans/library/collections/:collectionType/:collectionId"
    }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/library/:view", to: "/megascans/library/:view" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/library/products/bridge", to: "/bridge" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/library/products/bridge/:platform/:version", to: "/bridge" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/library/products/mixer", to: "/megascans/library/products/mixer" }),
    _react2.default.createElement(_reactRouter.Redirect, {
      from: "/library/products/mixer/:platform/:version",
      to: "/megascans/library/products/mixer/:platform/:version"
    }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/types/:type", to: "/megascans/library/types/:type" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/megascans/library/types/everything", to: "/megascans/library/latest" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/megascans/library/types/3d", to: "/megascans/library", query: { type: "3d" } }),
    _react2.default.createElement(_reactRouter.Redirect, {
      from: "/megascans/library/types/atlas",
      to: "/megascans/library",
      query: { type: "atlas" }
    }),
    _react2.default.createElement(_reactRouter.Redirect, {
      from: "/megascans/library/types/surface",
      to: "/megascans/library",
      query: { type: "surface" }
    }),
    _react2.default.createElement(_reactRouter.Redirect, {
      from: "/megascans/library/types/3dplant",
      to: "/megascans/library",
      query: { type: "3d", search: "plant" }
    }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/megascans/library/types/:type", to: "/megascans/library/home" }),
    _react2.default.createElement(_reactRouter.Redirect, {
      from: "/megascans/library/packs/:pack",
      to: "/megascans/library/collections/nature/:pack"
    }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/megascans/library/products/bridge", to: "/bridge" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/megascans/library/products/bridge/:platform/:version", to: "/bridge" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/library/types/everything", to: "/megascans/library/latest" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/library/types/3d", to: "/megascans/library", query: { type: "3d" } }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/library/types/atlas", to: "/megascans/library", query: { type: "atlas" } }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/library/types/surface", to: "/megascans/library", query: { type: "surface" } }),
    _react2.default.createElement(_reactRouter.Redirect, {
      from: "/library/types/3dplant",
      to: "/megascans/library",
      query: { type: "3d", search: "plant" }
    }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/library/types/:type", to: "/megascans/library/home" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/library/packs/:pack", to: "/megascans/library/collections/nature/:pack" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/packs/:pack", to: "/megascans/library/collections/nature/:pack" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/profile", to: "/megascans/library/account" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/signup", to: "/" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/apps/studio", to: "/mixer" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/apps/mixer", to: "/mixer" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/apps/bridge", to: "/bridge" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/products/studio", to: "/mixer" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/apps", to: "/" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "products/studio/:platform/:version", to: "/mixer/:platform/:version" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/mixer", to: "/" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/about", to: "/" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/jobs", to: "/" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/education", to: "/" }),
    _react2.default.createElement(_reactRouter.Redirect, { from: "/gallery", to: "/" }),
    _react2.default.createElement(_reactRouter.Route, { path: "/bridge", component: _Bridge2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: "/mixer", component: _Mixer2.default }),
    _react2.default.createElement(_reactRouter.Route, { name: "megascans", path: "/megascans", component: _Megascans2.default }),
    _react2.default.createElement(_reactRouter.Route, {
      name: "megascans",
      path: "/megascans/purchased",
      onEnter: ExternalRedirect,
      component: _Megascans2.default
    }),
    _react2.default.createElement(_reactRouter.Route, { path: "/assets/:asset/:manage", component: _components.AssetPopup, onEnter: ExternalRedirect }),
    _react2.default.createElement(_reactRouter.Route, { path: "/assets/:asset", component: _components.AssetPopup, onEnter: ExternalRedirect }),
    _react2.default.createElement(_reactRouter.Route, { path: "/pricing", component: _Pricing2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: "/enterprise", component: _Enterprise2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: "/plugins", component: _Plugins2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: "/subscribe/:plan", component: _Subscribe2.default, onEnter: requireLogin }),
    _react2.default.createElement(_reactRouter.Route, {
      path: "/choose/:name",
      onEnter: function onEnter(nextState, replace, cb) {
        var name = nextState.params.name;

        if (name === "studio") {
          var pathname = "/pricing";
          replace({
            pathname: pathname
          });
        }
        cb();
      },
      component: _ChooseSubscription2.default
    }),
    _react2.default.createElement(_reactRouter.Route, { path: "/blog", component: _Blog2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: "/blog/:index", component: _Blog2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: "/blog/:year/:date/:day/:index", component: _Articles2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: "/gallery", component: _Gallery2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: "/gallery/:index", component: _components.GalleryPopup }),
    _react2.default.createElement(_reactRouter.Route, { path: "/terms", component: ExternalRedirect }),
    _react2.default.createElement(_reactRouter.Route, { path: "/termsmixer", component: ExternalRedirect }),
    _react2.default.createElement(_reactRouter.Route, { path: "/cookiepolicy", component: _CookiePolicy2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: "/purchase/:id", component: _BuyPoints2.default, onEnter: requireLogin }),
    _react2.default.createElement(_reactRouter.Route, { path: "/upgrade/:to", component: _Upgrade2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: "*", component: _NotFound2.default })
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/pages/routes.jsx
// module id = 2363
// module chunks = 0